import { FeeSubProductDTO } from "@models/platform-analysis/entities/steps/fee";
import { useTheme } from "@mui/material";
import { Image, Text, View } from "@react-pdf/renderer";
import { isEmpty } from "lodash";
import {
  PDFDefaultPlatformLogoS3,
  PDFStyleConfigs,
  USE_PDF_LOCAL_ASSETS,
} from "../../configs";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { generatePDFImageIconUrl } from "../../utils";
import { getProductRecommendationConfigs } from "../../../../utils";

export const PDFFeeSubProductCard = ({
  subProduct,
  showRecommendationLabel,
}: {
  subProduct: FeeSubProductDTO;
  showRecommendationLabel: boolean;
}) => {
  const { palette } = useTheme();
  const { typographyStyle } = useAnalysisPDFStyles();

  const subProductName = `${subProduct.name}${
    !subProduct.isLatest && subProduct.outdatedAt ? ` (Outdated)` : ""
  }`;
  const hasManyFeeColumns =
    subProduct?.feeDetails?.length >
    PDFStyleConfigs.FeeAnalysisMaxFeeDetailsColumnToDisplayLogo;
  const { backgroundColor } = getProductRecommendationConfigs(
    subProduct.recommendation,
  );

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        maxWidth: hasManyFeeColumns
          ? PDFStyleConfigs.FeeAnalysisSubProductCardHasManyFeeColumns
          : PDFStyleConfigs.FeeAnalysisSubProductCardHasNoManyFeeColumns,
      }}
    >
      {showRecommendationLabel && (
        <View
          style={{
            width:
              PDFStyleConfigs.FeeAnalysisSubProductCardRecommendationBadgeWidth,
            alignSelf: "stretch",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: "50%",
            borderBottomLeftRadius: "50%",
          }}
        />
      )}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          maxWidth: hasManyFeeColumns
            ? showRecommendationLabel
              ? PDFStyleConfigs.FeeAnalysisSubProductCardHasManyFeeColumns -
                PDFStyleConfigs.FeeAnalysisSubProductCardRecommendationBadgeWidth
              : PDFStyleConfigs.FeeAnalysisSubProductCardHasManyFeeColumns
            : showRecommendationLabel
            ? PDFStyleConfigs.FeeAnalysisSubProductCardHasNoManyFeeColumns -
              PDFStyleConfigs.FeeAnalysisSubProductCardRecommendationBadgeWidth
            : PDFStyleConfigs.FeeAnalysisSubProductCardHasNoManyFeeColumns,
        }}
      >
        {!hasManyFeeColumns &&
          (subProduct?.productLogo?.url && !USE_PDF_LOCAL_ASSETS ? (
            <Image
              src={generatePDFImageIconUrl(subProduct?.productLogo?.url)}
              style={{ width: 25, height: 25, objectFit: "contain" }}
            />
          ) : (
            <Image
              src={PDFDefaultPlatformLogoS3}
              style={{ width: 25, height: 25, objectFit: "contain" }}
            />
          ))}

        <View style={{ justifyContent: "space-between" }}>
          <Text
            style={{
              ...typographyStyle.body2,
              lineHeight: 1.2,
              maxWidth: 72,
              fontWeight: "bold",
            }}
          >
            {`${subProduct.productName} `}
            {!isEmpty(subProduct?.warning) && (
              <Text
                style={{
                  ...typographyStyle.body2,
                  color: palette.error.main,
                }}
              >
                {`*`}
              </Text>
            )}
          </Text>
          <Text
            style={{
              ...typographyStyle.body2,
              lineHeight: 1.1,
              maxWidth: 90,
            }}
          >
            {subProductName}
          </Text>
        </View>
      </View>
    </View>
  );
};
